import { Link } from "react-router-dom";
import classes from "./PromoCardItem.module.css";
import { useTranslation } from "react-i18next";

export const PromoCardItem = ({ item }) => {
	return (
		<Link className={classes.card} to={item?.buttonLink}>
			<div className={classes.container}>
				<div>
					<h1 className={classes.title} style={{ fontWeight: "normal" }}>
						{item?.title}
					</h1>

					{item?.content}
				</div>
				<button className={classes.button}>{item?.buttonText}</button>
			</div>
		</Link>
	);
};

export const KotikinoChristmasOffer = () => {
	const { i18n } = useTranslation();
	const isFi = i18n.language?.startsWith("fi");

	return (
		<Link
			to="/subscription"
			style={{
				textDecoration: "none",
				color: "inherit",
				display: "inline-block",
			}}
		>
			<div
				style={{
					position: "relative",
					backgroundColor: "#0f243a",
					borderRadius: "22px",
					// padding: "clamp(56px, 10vw, 76px) clamp(18px, 5vw, 28px)",
					padding: `
	clamp(56px, 10vw, 76px)
	clamp(18px, 5vw, 28px)
	clamp(28px, 6vw, 36px)
	clamp(18px, 5vw, 28px)
`,
					width: "80vw",
					maxWidth: "420px",
					margin: "0 auto",
					textAlign: "center",
					color: "#ffffff",
				}}
			>
				{/* Floating logo */}
				<img
					src="/logo.png"
					alt="Kotikino"
					style={{
						position: "absolute",
						top: "-36px",
						left: "50%",
						transform: "translateX(-50%)",
						width: "90px",
						zIndex: 2,
					}}
				/>

				{/* Title */}
				<div
					style={{
						fontSize: "clamp(1.8em, 6vw, 2.6em)",
						fontWeight: 500,
						letterSpacing: "0.22em",
						lineHeight: 1.1,
						marginBottom: "6px",
					}}
				>
					{isFi ? "KOTIKINON" : "KOTIKINO"}
				</div>

				<div
					style={{
						fontSize: "clamp(1.2em, 4.5vw, 1.6em)",
						fontWeight: 600,
						letterSpacing: "0.28em",
						lineHeight: 1.1,
						marginBottom: "28px",
					}}
				>
					{isFi ? "JOULUTARJOUS" : "CHRISTMAS OFFER"}
				</div>

				{/* Subtitle */}
				<div
					style={{
						fontSize: "1.15em",
						fontWeight: 400,
						marginBottom: "14px",
						opacity: 0.95,
					}}
				>
					{isFi ? "Ensimmäinen kuukausi" : "First month"}
				</div>

				{/* Price row */}
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "baseline",
						marginBottom: "26px",
						whiteSpace: "nowrap",
						flexWrap: "nowrap",
					}}
				>
					<span
						style={{
							fontSize: "1.05em",
							opacity: 0.9,
							marginRight: "8px",
						}}
					>
						{isFi ? "vain" : "only"}
					</span>

					<span
						style={{
							fontSize: "clamp(2.8em, 8vw, 4.2em)",
							fontWeight: 700,
							color: "#ff5a6f",
							lineHeight: 1,
						}}
					>
						1 €
					</span>

					<span
						style={{
							fontSize: "1.1em",
							opacity: 0.9,
							marginLeft: "4px",
						}}
					>
						/{isFi ? "kk" : "mo"}
					</span>
				</div>

				{/* Footer */}
				<div
					style={{
						fontSize: "14px",
						letterSpacing: "0.08em",
						opacity: 0.85,
						marginBottom: "6px",
					}}
				>
					{isFi ? "TARJOUS VOIMASSA 21.01.2026 ASTI" : "OFFER VALID UNTIL 21.01.2026"}
				</div>

				<div
					style={{
						fontSize: "13px",
						opacity: 0.6,
						marginBottom: "22px",
					}}
				>
					{isFi ? "normaalihinta 9,99 €/kk" : "regular price €9.99/month"}
				</div>

				{/* CTA Button */}
				<button
					style={{
						backgroundColor: "#ff5a6f",
						color: "#ffffff",
						border: "none",
						borderRadius: "10px",
						padding: "14px 18px",
						width: "100%",
						fontSize: "16px",
						fontWeight: 600,
						cursor: "pointer",
					}}
				>
					{isFi ? "Tilaa nyt" : "Subscribe now"}
				</button>
			</div>
		</Link>
	);
};
